import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Table, Button, Space, Select, message } from 'antd';

const { Title, Paragraph } = Typography;
const { Option } = Select;

const AssignTickets = () => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [admins, setAdmins] = useState([]);

  const columns = [
    { title: 'Ticket #', dataIndex: 'id', key: 'id', width: 100 },
    { title: 'Subject', dataIndex: 'subject', key: 'subject' },
    { title: 'Priority', dataIndex: 'priority', key: 'priority', width: 120 },
    { title: 'Current Assignee', dataIndex: 'assignee', key: 'assignee', width: 180 },
    {
      title: 'Assign To', key: 'assign', width: 260, render: (_, record) => (
        <Space>
          <Select
            style={{ width: 180 }}
            placeholder="Select admin"
            value={record.pendingAssignee}
            onChange={(val) => onChangeAssignee(record.id, val)}
          >
            {admins.map(a => <Option key={a} value={a}>{a}</Option>)}
          </Select>
          <Button size="small" type="primary" onClick={() => onAssign(record)}>Assign</Button>
        </Space>
      )
    }
  ];

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => {
      setAdmins(['Rami', 'Sara Admin', 'Support Bot']);
      setRows([
        { id: 2011, subject: 'Integration help', priority: 'medium', assignee: '-', pendingAssignee: undefined },
        { id: 2012, subject: 'Payment failed', priority: 'high', assignee: 'Sara Admin', pendingAssignee: 'Rami' },
      ]);
      setLoading(false);
    }, 250);
    return () => clearTimeout(t);
  }, []);

  const onChangeAssignee = (id, value) => {
    setRows(prev => prev.map(r => r.id === id ? { ...r, pendingAssignee: value } : r));
  };

  const onAssign = (record) => {
    if (!record.pendingAssignee) {
      message.warning('Select an admin to assign');
      return;
    }
    // PUT /api/support/tickets/:id/assign
    setRows(prev => prev.map(r => r.id === record.id ? { ...r, assignee: record.pendingAssignee } : r));
    message.success(`Ticket #${record.id} assigned to ${record.pendingAssignee}`);
  };

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[{ title: 'Admin' }, { title: 'Support' }, { title: 'Assign Tickets' }]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Assign Tickets</Title>
      </div>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>Assign open tickets to admins.</Paragraph>
        <Table rowKey="id" columns={columns} dataSource={rows} loading={loading} pagination={{ pageSize: 10 }} />
      </Card>
    </div>
  );
};

export default AssignTickets;
